"use client";

import { c as _c } from "react/compiler-runtime";
import { Cancel01Icon, Menu01Icon } from "@hugeicons/core-free-icons";
import { HugeiconsIcon } from "@hugeicons/react";
import Image from "next/image";
import Link from "next/link";
import { useEffect, useRef, useState } from "react";
import { Button } from "@/components/ui/button";
import { navLinks } from "@/lib/site-links";

/**
 * A navigation menu component that appears at the top of the page. Includes site links and a theme mode toggle.
 */
export function NavMenu() {
  const $ = _c(14);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const menuRef = useRef(null);
  let t0;
  let t1;
  if ($[0] !== mobileMenuOpen) {
    t0 = () => {
      if (!mobileMenuOpen) {
        return;
      }
      const handleClickOutside = function handleClickOutside(event) {
        if (menuRef.current && !menuRef.current.contains(event.target as Node)) {
          setMobileMenuOpen(false);
        }
      };
      document.addEventListener("mousedown", handleClickOutside);
      return () => document.removeEventListener("mousedown", handleClickOutside);
    };
    t1 = [mobileMenuOpen];
    $[0] = mobileMenuOpen;
    $[1] = t0;
    $[2] = t1;
  } else {
    t0 = $[1];
    t1 = $[2];
  }
  useEffect(t0, t1);
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <Link href="/#home" className="font-bold flex items-center gap-2"><Image src="/jkww-icon.png" alt="JK Web Works Logo" height={28} width={28} /><span className="mt-0 text-primary text-base md:text-xl">JK Web Works</span></Link>;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = navLinks.length > 0 && <nav className="hidden md:flex md:items-center md:gap-1">{navLinks.map(_temp)}</nav>;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== mobileMenuOpen) {
    t4 = navLinks.length > 0 && <Button variant="outline" size="icon-sm" className="md:hidden" onClick={() => setMobileMenuOpen(_temp2)} aria-expanded={mobileMenuOpen} aria-label={mobileMenuOpen ? "Close menu" : "Open menu"}><HugeiconsIcon icon={mobileMenuOpen ? Cancel01Icon : Menu01Icon} className="h-[1.2rem] w-[1.2rem]" /></Button>;
    $[5] = mobileMenuOpen;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t4) {
    t5 = <div className="mx-auto flex justify-between items-center gap-3 h-12 max-w-4xl rounded-xl border border-border bg-background px-2 text-2xl md:flex-row md:justify-between md:gap-0 animate-fade-in-delayed fill-mode-both">{t2}<div className="flex items-center gap-3">{t3}{t4}</div></div>;
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== mobileMenuOpen) {
    t6 = mobileMenuOpen && navLinks.length > 0 && <nav className="mt-1 mx-auto max-w-7xl rounded-xl border border-border bg-background p-4 md:hidden animate-fade-in fill-mode-both"><ul className="flex flex-col gap-1">{navLinks.map(link_0 => <li key={link_0.label}><Link href={link_0.href} onClick={() => setMobileMenuOpen(false)} className="block p-3 rounded-md text-base hover:bg-secondary hover:drop-shadow-sm transition-all">{link_0.label}</Link></li>)}</ul></nav>;
    $[9] = mobileMenuOpen;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== t5 || $[12] !== t6) {
    t7 = <header className="fixed inset-x-0 z-50 px-2 top-2 md:px-4 md:top-2" ref={menuRef}>{t5}{t6}</header>;
    $[11] = t5;
    $[12] = t6;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  return t7;
}
function _temp2(prev) {
  return !prev;
}
function _temp(link) {
  return <Link key={link.label} href={link.href} className="p-1 rounded-md text-sm hover:bg-secondary hover:drop-shadow-sm transition-all">{link.label}</Link>;
}